<h2 mat-dialog-title>Permanently delete task?</h2>

<mat-dialog-content>
  <p>
    If you delete this task all child tasks, all task history and all
    discussions attached to this and all child tasks will be deleted forever.
    This deletion cannot be undone.
  </p>

  <p>Are you sure you want to delete all permanently?</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="accept()" color="warn">
    Delete all permanently
  </button>
</mat-dialog-actions>
